import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './helpers/createBaseQuery';
import { IApplicationContext } from '../types/applicationContext';
import {
  fetchPublicB2cV2GetAvailableMultiOffers,
  TPublicB2cV2GetAvailableMultiOffersRequest,
  TPublicB2cV2GetAvailableMultiOffersResponse_1,
} from '../repositories/mortgage-broker-calculator/b2c/v2/get-available-multi-offers';

export let landingApi: ReturnType<typeof createLandingApi>;
export type TLandingApiEndpoints = keyof typeof landingApi.endpoints;

export const createLandingApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'landingApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getOfferListingV2: builder.query<
        TPublicB2cV2GetAvailableMultiOffersResponse_1,
        TPublicB2cV2GetAvailableMultiOffersRequest
      >({
        query: parameters => ({
          parameters,
          fetchFunction: fetchPublicB2cV2GetAvailableMultiOffers,
          loggerInfo: {
            description: 'Получение данных для листинга',
            degradation: 'Отображение критической ошибки, листинг недоступен',
          },
        }),
      }),
    }),
  });

  landingApi = newApi;

  return newApi;
};
